/*!
 * ignore
 */

'use strict';

module.exports = require('bson').Decimal128;



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/drivers/browser/decimal128.js
// module id = 357
// module chunks = 0